import { render, staticRenderFns } from "./YearTransition.vue?vue&type=template&id=39497688&"
import script from "./YearTransition.vue?vue&type=script&lang=js&"
export * from "./YearTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports